module.exports = __webpack_public_path__ + "static/img/20200518-2.dd315ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-2.png
// module id = RrjM
// module chunks = 1